function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 63.167,
  cy: 63.167,
  r: 61.667,
  stroke: "#fff",
  strokeWidth: 3
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.34 54.277c-10.61 0-19.67 6.26-23.34 15.097 3.67 8.838 12.73 15.098 23.34 15.098 10.608 0 19.668-6.26 23.339-15.097-3.67-8.838-12.73-15.098-23.34-15.098zm0 25.163c-5.857 0-10.61-4.51-10.61-10.066 0-5.555 4.753-10.065 10.61-10.065 5.856 0 10.608 4.51 10.608 10.066 0 5.555-4.752 10.065-10.608 10.065zm0-16.105c-3.523 0-6.366 2.698-6.366 6.04 0 3.341 2.843 6.039 6.366 6.039 3.522 0 6.365-2.698 6.365-6.04 0-3.341-2.843-6.039-6.365-6.039zM92.269 38.253v-5.319h-5.803v5.32l2.901 2.9 2.902-2.9zm-7.254 1.451h-5.319v5.803h5.32l2.9-2.902-2.9-2.901zm1.451 7.253v5.32h5.803v-5.32l-2.902-2.901-2.901 2.901zm7.253-7.253l-2.901 2.901 2.901 2.902h5.32v-5.803h-5.32z",
  fill: "#fff"
});

const SvgTrackingCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 127 127",
  fill: "none"
}, props), _ref, _ref2);

export default SvgTrackingCircle;